<template>
    <div>
        <base-input-select
            :select-options="placementOptions"
            @input="selectOption"
        />
    </div>
</template>

<script>
    import BaseInputSelect from './BaseInputSelect.vue';

    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        components: {
            BaseInputSelect,
        },

        props: {
            placement: {
                type: Object,
                required: true,
            },
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            selectedValue() {
                return this.placement.selectedValue;
            },

            /**
             * Pre-format the list of options.
             */
            swatchOptions() {
                return this.customizerStore.sortOptions(this.placement, this.selectedValue);
            },

            placementOptions() {
                return this.swatchOptions.map((o) => ({
                    label: o.label,
                    code: o.value,
                    selected: o.selected,
                }));
            },
        },

        methods: {
            selectOption(option) {
                this.customizerStore.setSelection(this.placement.code, option.code, false);
            },
        },
    };
</script>
